/**
 * homeTabPref.ts — Home tabs H-3b-1 (the H-3b recon rulings, Klemen 2026-10-19): the
 * last Home tab and the London day of the last Home visit, device-local in
 * localStorage under the gss.pref. namespace (the excludeTestPref precedent).
 *
 * A stand-in for the spec's server-side `home_tab` preference (§6): per
 * device, never per account. Reads and writes go through draftStorage, so a
 * blocked or full storage is NON-FATAL — a failed read is "nothing
 * remembered", which opens Overview (or My day on a first visit with items).
 */
import { readDraft, writeDraft } from './draftStorage'
import { isHomeTab, type HomeTab } from '../components/dashboard/pages/sales/homeView'

export const HOME_TAB_KEY = 'gss.pref.homeTab'
export const HOME_VISIT_DAY_KEY = 'gss.pref.homeVisitDay'

export function readHomeTab(): HomeTab | null {
  const v = readDraft<unknown>(HOME_TAB_KEY)
  return isHomeTab(v) ? v : null
}

export function writeHomeTab(tab: HomeTab): void {
  writeDraft(HOME_TAB_KEY, tab)
}

/** The London day ("2026-10-20") of the last Home visit, or null. */
export function readHomeVisitDay(): string | null {
  const v = readDraft<unknown>(HOME_VISIT_DAY_KEY)
  return typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v) ? v : null
}

export function writeHomeVisitDay(day: string): void {
  writeDraft(HOME_VISIT_DAY_KEY, day)
}
